import React, { useEffect, useMemo } from "react";
import { default as MainHeaderApp } from "@appsinti/ui-core/header";
import { ArrowLeftIcon } from "@etiquette-ui/icons";
import { useData } from "../../../../../../data";
import BarChart from "@appsinti/stats-frontend/home/components/charts/bar";
import RangeDateItem from "../../components/RangeDateItem";
import Loader from "../../../../../../components/charts/components/Loader";
import Card from "../../../../containers/Card";
import Content from "../../../../containers/Content";
const { getSortedRangeDatesId } = require("@appsinti/stats-utils");
import NewItemButton from "../../../../components/NewItemButton";

const Main: React.FC = () => {
  const {
    sales,
    fetchSales,
    fetchSpecialRangeDatesConfig,
    specialRangeDatesConfig,
  } = useData();

  useEffect(() => {
    fetchSpecialRangeDatesConfig();
    fetchSales();
  }, []);

  const dataObject = (sales ?? []).find(el => el.key === 'rangeDates');

  const rangeDates = useMemo(() => {
    if (!specialRangeDatesConfig) return undefined;

    return getSortedRangeDatesId(specialRangeDatesConfig);
  }, [specialRangeDatesConfig]);

  return (
    <>
      <MainHeaderApp
        title={"Edit Special Range Dates"}
        icon={<ArrowLeftIcon styles={{}} />}
        backButtonLocation="../.."
      />
      <Content>
        {sales?.rangeDates && (
          <BarChart
            dataObject={dataObject}
          />
        )}
        <Card
          body={
            !!rangeDates && !!specialRangeDatesConfig ? (
              <>
                {rangeDates.map((rangeDateId) => (
                  <RangeDateItem key={rangeDateId} rangeDate={specialRangeDatesConfig[rangeDateId]} rangeDateId={rangeDateId} />
                ))}
                <NewItemButton to="range-date" />
              </>
            ) : (
              <Loader />
            )
          }
        />
      </Content>
    </>
  );
};
export default Main;